import { Button, Typography, Form, Input, notification } from "antd";
import { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import authService from "../../services/auth-service";
import { COMPANY_LOGO } from "../../constants";

const { Title } = Typography

const styles = { borderRadius: "10px", height: "40px" }

const ResetPassword = () => {

    let [form] = Form.useForm();
    const { token } = useParams();
    const navigate = useNavigate();
    let location = useLocation();

    const [loading, setLoading] = useState(false)

    const onFinish = async (values) => {
        const data = { ...values, token };
        setLoading(true)
        const response = await authService.resetPassword(data);
        setLoading(false)

        if (response?.success ?? false) {
            navigate('/login', { state: { email: data.email } });
            notification.success({ message: "Success", description: response.message, placement: "topRight" });
        }
    }

    const onFinishFailed = (errorInfo) => {
        console.error("Failed:", errorInfo);
    };

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            textAlign: "center",
        }}>
            <img
                src={COMPANY_LOGO}
                alt="ctrade-Logo"
                className="h-10 w-auto"
                style={{ width: "370px", height: "120px" }}
            />

            <Title id="title" style={{ fontSize: "20px" }}>Reset Password</Title>
            <br />
            <Form
                style={{ width: "350px", }}
                form={form}
                layout="vertical"
                name="basic"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={{ email: new URLSearchParams(location.search).get("email") ?? null }}
            >

                <Form.Item
                    name="email"
                    label="E-Mail Address"
                >
                    <Input type="email" style={styles} placeholder="Enter your email" readOnly />
                </Form.Item>

                <Form.Item
                    label="Password"
                    name="password"
                    rules={[{ required: true, message: "Please input password!" }]}
                >
                    <Input.Password placeholder="Enter password" style={styles} />
                </Form.Item>

                <Form.Item
                    label="Confirm Password"
                    name="password_confirmation"
                    dependencies={["password"]}
                    rules={[
                        {
                            required: true,
                            message: "Please input confirm password!",
                        },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue("password") === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(
                                    new Error("Passwords do not match!")
                                );
                            },
                        })
                    ]}
                >
                    <Input.Password placeholder="Enter confirm password" style={styles} />
                </Form.Item>

                <Button type="primary" htmlType="submit" loading={loading}>Reset Password</Button>
            </Form>
        </div>
    );

}
export default ResetPassword